import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { CartPromotion } from "@omni/types/api/cart/bff/shared/cartPromotion.model";
import {
    CartImpressionTrackingInfo,
    CartImpressionTrackingInfoItem,
    CartImpressionTrackingInfoPromotion
} from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import { ArrayMapper } from "@omni/types/utils/arrayMapper";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { pick } from "@omni/utils/object.utils";

const warrantyProductInfo = {
    name: "Waarborg pallet",
    analytics: {
        productTitle: "Waarborg pallet",
        superCategoryCode: "waarborg",
        superCategoryName: "Waarborg"
    }
};

export const toCartImpressionTrackingInfoPromotion: ModelMapper<
    CartPromotion,
    CartImpressionTrackingInfoPromotion
> = (item) => {
    return pick(item, ["id"]);
};

export const toCartImpressionTrackingInfoItem: ArrayMapper<
    CartItem,
    CartImpressionTrackingInfoItem
> = (item, index) => {
    const analytics = item.warrantyDeposit
        ? item.product?.analytics || warrantyProductInfo.analytics
        : item.product?.analytics;

    const { superCategoryCode = "" } = analytics || {};

    const reduction =
        (item.articleStrikethroughPrice
            ? item.articleStrikethroughPrice
            : item.articleSalesPrice) - item.articleSalesPrice;

    return {
        name:
            (item.warrantyDeposit
                ? item.product?.productTitle ||
                  item.product?.analytics.productTitle ||
                  warrantyProductInfo.name
                : item.product?.productTitle) || "",

        id: item.sku,
        ean: item.product?.ean,
        category: superCategoryCode,
        price: item.articleSalesPrice,
        unitPrice: item.articleSalesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: item.quantity,
        url: item.product?.url,
        placement: index + 1,
        brand: item.product?.brandName || ""
    };
};

export const toCartImpressionTrackingInfo: ModelMapper<
    Cart,
    CartImpressionTrackingInfo
> = (cart) => {
    return {
        name: "cart quickview",
        totalPrice: cart.totalPrice,
        promotions: cart.promotions.map(toCartImpressionTrackingInfoPromotion),
        globalDiscounts: cart.globalDiscounts,
        items: cart.items
            ?.filter((item) => !!item.product)
            .map(toCartImpressionTrackingInfoItem)
    };
};
